<template>
  <van-pull-refresh
    v-model="isLoading"
    :success-text="$18nText(158)"
    :loosing-text="$18nText(159)"
    :pulling-text="$18nText(160)"
    :loading-text="$18nText(161)"
    @refresh="onRefresh"
    class="fatherBox"
  >
    <div class="list" v-for="(pItem, pIndex) in tripRecordsLsit" :key="pIndex">
      <p class="title">
        {{
          pItem.monthName == $moment().format('yyyy-MM')
            ? $18nText(157)
            : pItem.monthName
        }}
      </p>
      <van-swipe-cell v-for="(item, index) in pItem.records" :key="index">
        <div class="item clear" @click="toDetails(item)">
          <div class="fl image">
            <img :src="item.imgUrl" />
          </div>
          <div class="fl">
            <p class="time">{{ item.startTime }}</p>
            <p class="distance">{{ item.currentMileage }}km</p>
            <p class="remarks">
              <img src="../../assets/time.png" />
              {{ item.totalTime }}
              <img src="../../assets/banner.png" />
              {{ item.topSpeed }}km/h
            </p>
          </div>
        </div>
        <template #right>
          <van-button
            style="height: 100%"
            square
            :text="$18nText(72)"
            type="danger"
            @click="delTrackRecord(item)"
            class="delete-button"
          />
        </template>
      </van-swipe-cell>
    </div>
  </van-pull-refresh>
</template>
<script>
import { listMonthlyTrackRecord, delTrackRecord } from '@/api/stroke';
// import { setToken } from "@/utils/auth";
// import { monitor } from "@/utils/webView";
export default {
  data() {
    return {
      tripRecordsLsit: [],
      isLoading: false
    };
  },
  activated() {
    this.firstList();
  },
  methods: {
    toDetails(row) {
      //   this.$router.push({ path: "ItineraryDetails", query: { id: row.id } });
      this.$winOpen({ path: 'ItineraryDetails', query: { id: row.id } });
      //   window.open("http://192.168.31.22:8080/ItineraryDetails");
    },
    firstList(callback) {
      listMonthlyTrackRecord().then(res => {
        this.tripRecordsLsit = res.data;
        if (callback) callback();
      });
    },
    onRefresh() {
      this.firstList(() => {
        this.isLoading = false;
      });
    },
    delTrackRecord(row) {
      delTrackRecord({ id: row.id }).then(res => {
        this.firstList(() => {
          this.$toast(this.$18nText(188));
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.fatherBox {
  min-height: 100vh;
  background: #fafafa;
  /deep/ .van-pull-refresh__track {
    min-height: calc(100vh - 0.1rem);
  }
  .list {
    padding-top: 0.4rem;
    position: relative;
    .title {
      position: absolute;
      top: 0;
      left: 0.2rem;
      font-size: 0.2rem;
      font-weight: 500;
      color: rgba(43, 47, 56, 1);
      line-height: 0.42rem;
      height: 0.4rem;
    }
    .item {
      padding: 0.2rem;
      background: #fff;
      border-bottom: 1px solid #cccccc;
      transition: 0.1s;
      &:last-child {
        border: none;
      }
      .image {
        padding-right: 0.2rem;
        img {
          width: 1.2rem;
          height: 1.2rem;
          display: block;
        }
      }
      .time {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(43, 47, 56, 1);
      }
      .distance {
        font-size: 0.42rem;
        font-weight: bold;
        line-height: 0.59rem;
        color: rgba(43, 47, 56, 1);
      }
      .remarks {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(43, 47, 56, 1);
        img {
          vertical-align: sub;
          width: 0.28rem;
          height: 0.28rem;
          margin-right: 0.08rem;
          &:nth-child(2) {
            margin-left: 0.25rem;
          }
        }
      }
    }
  }
}
</style>
